__turbopack_context__.v({
  "card": "SkeletonLoaderCard-module-scss-module__uMnKja__card",
  "card-content": "SkeletonLoaderCard-module-scss-module__uMnKja__card-content",
  "card-content-wrapper": "SkeletonLoaderCard-module-scss-module__uMnKja__card-content-wrapper",
  "card-image": "SkeletonLoaderCard-module-scss-module__uMnKja__card-image",
  "card-with-border": "SkeletonLoaderCard-module-scss-module__uMnKja__card-with-border",
  "shine": "SkeletonLoaderCard-module-scss-module__uMnKja__shine",
});
